import { render, staticRenderFns } from "./TimeLimitInput.vue?vue&type=template&id=be05a94a&scoped=true"
import script from "./TimeLimitInput.vue?vue&type=script&lang=js"
export * from "./TimeLimitInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be05a94a",
  null
  
)

export default component.exports